export var DefaultExposeGroupEnum;
(function (DefaultExposeGroupEnum) {
    DefaultExposeGroupEnum["PROFILER"] = "profiler";
    DefaultExposeGroupEnum["FIXTURE"] = "fixture";
    DefaultExposeGroupEnum["MODEL"] = "model";
    DefaultExposeGroupEnum["READ"] = "read";
    DefaultExposeGroupEnum["CREATE"] = "create";
    DefaultExposeGroupEnum["UPDATE"] = "update";
    DefaultExposeGroupEnum["PATCH"] = "patch";
    DefaultExposeGroupEnum["PUT"] = "put";
    DefaultExposeGroupEnum["DELETE"] = "delete";
})(DefaultExposeGroupEnum || (DefaultExposeGroupEnum = {}));
//# sourceMappingURL=DefaultExposeGroupEnum.js.map